var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxDurationBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 55,
    viewBox: "0 0 156 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_466)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.03
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44442 39.5166H-1.55626C-2.62231 39.5166 -3.59233 40.1327 -4.04555 41.0976L-21.0469 77.294C-21.9035 79.1179 -20.5726 81.2134 -18.5576 81.2134H-7.37413C-6.30396 81.2134 -5.33096 80.5926 -4.88001 79.6221L11.9385 43.4257C12.7856 41.6027 11.4546 39.5166 9.44442 39.5166Z",
    fill: "#1EB0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3605 39.5166H43.2532C45.261 39.5166 46.5921 41.5984 45.7496 43.4209L38.6053 58.8741C38.1554 59.8473 37.1811 60.4703 36.109 60.4703H20.9149L28.9627 77.2753C29.8369 79.1008 28.5063 81.2134 26.4822 81.2134H15.5021C14.4358 81.2134 13.4656 80.597 13.0125 79.6317L5.85815 64.389C5.00211 62.5652 6.33302 60.4703 8.34777 60.4703H20.9149L29.8642 41.1127C30.314 40.1396 31.2884 39.5166 32.3605 39.5166Z",
    fill: "#1EB0FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 54,
    fill: "white",
    transform: "translate(0 0.893555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDurationBg);
export default __webpack_public_path__ + "static/media/BoxDurationBg.bb1ef8be359b41319b70d30911b42107.svg";
export { ForwardRef as ReactComponent };